import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute3 = ({
  width = 100,
  height = 356,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 382,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 356"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M5.37109 5.10645C13.4139 24.9202 24.0481 41.2435 39.8383 58.5266C85.4611 108.463 111.531 125.832 91.9786 234.389C83.1209 283.567 73.0901 323.378 66.3704 355.107"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M5.37109 5.10645C13.4139 24.9202 24.0481 41.2435 39.8383 58.5266C85.4611 108.463 111.531 125.832 91.9786 234.389C83.1209 283.567 73.0901 323.378 66.3704 355.107"
      />
      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M4.31674 1.95396C4.36361 1.72783 4.63771 1.63723 4.81011 1.79089L9.55119 6.01647C9.72359 6.17013 9.665 6.4528 9.44573 6.52527L3.41573 8.51838C3.19646 8.59085 2.98095 8.39878 3.02782 8.17265L4.31674 1.95396Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute3
